module.exports = __webpack_public_path__ + "img/32.ce65aa33.png";